module.exports = "file2";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/extract-require/folder/file2.js
 ** module id = 3
 ** module chunks = 0
 **/